<route lang="json">
{
  "name": "classroom_screen-public-page-show"
}
</route>
<script setup lang="ts">
import { type ClassroomScreenPage } from "@/services/fobizzToolsApi";
import { type User } from "@/services/orval/internalApiV1";
import { useClassroomScreenStore } from "@/stores/classroomScreen";
import { useRoute } from "vue-router";

const namespace = "classroom_screen";

const route = useRoute("classroom_screen-public-page-show");

const appsStore = useAppsStore();
const app = appsStore.findAppByNamespace(namespace);

// we assume that the store is initialized by the parent component
const screenStore = useClassroomScreenStore();

const screen = screenStore.screen;
const currentPageId = route.params.pageId;

const currentPage = ref<ClassroomScreenPage>();
currentPage.value = screenStore.findPageById(currentPageId);

const userStore = useUserStore();
const isAuthor = computed(
  () => screen.userId === (userStore.user as User)?.toolsUserId
);

const routes = createRouteNamesFromNamespace(namespace);

const pageShowRouteName = computed(() =>
  route.name === "classroom_screen-public-page-show"
    ? "classroom_screen-public-page-show"
    : "classroom_screen-page-show"
);

watch(
  () => route.params.pageId,
  (pageId) => {
    currentPage.value = screenStore.findPageById(pageId as string);
  }
);
</script>
<template>
  <div v-if="screen && currentPage && app">
    <NavbarToolEdit
      v-if="isAuthor"
      :app="app"
      :item="screen"
      :routes="routes"
      :subscribers="screenStore.getSortedSubscribers"
      :hide-preview="true"
    >
      <template #edit-actions>
        <SaveImageDropdownLink :image-name="screen.name || ''" />
      </template>
    </NavbarToolEdit>

    <NavbarToolPublic
      v-else
      :app="app"
      :item="screen"
      :subscribers="screenStore.getSortedSubscribers"
      :route-name-show="routes.show"
      :hide-print-link="true"
    >
      <template #public-dropdown>
        <SaveImageDropdownLink :image-name="screen.name || ''" />
      </template>
    </NavbarToolPublic>

    <div class="main-view">
      <ClassroomScreenPage
        v-if="app"
        class="d-none d-md-block"
        :app="app"
        :screen="screen"
        :page="currentPage"
        :route-name-show="pageShowRouteName"
      />
      <RouterView :item="screen" :page="currentPage" />
      <div class="d-flex d-md-none">
        <ClassroomScreenHintScreensize />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.main-view {
  margin-top: $navbar-height;
}
</style>
